import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: '',
    title: 'Inicio',
    data: { title: 'Inicio' /* withPadding: true */ },
    loadComponent: () => import('./pages/home/home.component'),
  },
];
